export const isEmpty = value => (value === null || value === undefined || value === "")